import { Dropdown } from "primereact/dropdown";
import { useEffect, useMemo } from "react";
import { useInstallationsQuery } from "../../queries/data-analysis.query";

export interface InstallationSelectorProps {
  selectedInstallationId?: number;
  allowEmpty?: boolean;
  onInstallationIdChange: (installationId: number | null) => void;
}

export function InstallationSelector({
  selectedInstallationId,
  allowEmpty = false,
  onInstallationIdChange,
}: InstallationSelectorProps) {
  const { data } = useInstallationsQuery();

  const sortedData = useMemo(
    () => data?.slice().sort((a, b) => a.name.localeCompare(b.name)),
    [data],
  );

  useEffect(() => {
    if (
      !allowEmpty &&
      !selectedInstallationId &&
      sortedData &&
      sortedData.length > 0
    ) {
      onInstallationIdChange(sortedData[0].id);
    }
  }, [selectedInstallationId, sortedData, allowEmpty, onInstallationIdChange]);

  return (
    <div>
      {sortedData && (
        <Dropdown
          options={sortedData}
          onChange={(e) => onInstallationIdChange(e.value ?? null)}
          value={selectedInstallationId}
          showClear={allowEmpty}
          optionLabel="name"
          optionValue="id"
          filter
          filterBy="name"
          className="mr-2 !w-72 shadow-md"
          scrollHeight="400px"
          appendTo="self"
        />
      )}
    </div>
  );
}
